import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Intro from './components/Intro'
import Questionnaire from './components/Questionnaire'
import Welcome from './components/Welcome'
import RecommendationByTopic from './components/RecommendationByTopic'
import MailRequest from './components/MailRequest'
import MailConfirmation from "./components/MailConfirmation";
import Wait from "./components/Wait"

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/index.html',
      name: 'homeWithIndex',
      component: Home
    },
    {
      path: '/willkommen',
      name: 'welcome',
      component: Welcome
    },
    {
      path: '/intro',
      name: 'intro',
      component: Intro
    },
    {
      path: '/fragen',
      name: 'questionnaire',
      component: Questionnaire
    },
    {
      path: '/wait',
      name: 'wait',
      component: Wait
    },
    {
      path: '/recommendation',
      name: 'recommendation',
      component: RecommendationByTopic
    },
    {
      path: '/mailrequest',
      name: 'mailrequest',
      component: MailRequest
    },
    {
      path: '/mailconfirmation',
      name: 'mailconfirmation',
      component: MailConfirmation
    }
  ]
})
